<script>
    import {
        getContext,
        onDestroy,
        onMount,
        createEventDispatcher,
    } from 'svelte'
    export let label = null
    export let icon = null
    export let alt = ''
    export let active = false
    const dispatch = createEventDispatcher()
    const currentTab = getContext('currentTab')
    const tabData = getContext('tabData')
    const events = getContext('events')
    const { index } = getContext('setIndex')
    const id = index ? index() : null
    onMount(() => {
        if (tabData) {
            tabData.update((d) => [...d, { label, icon, alt, id }])
        }
        if (active) {
            currentTab.set(id)
        }
    })
    onDestroy((_) => {
        if (tabData) {
            tabData.update((d) => d.filter((t) => t.id !== id))
        }
    })
    $events[id] = {
        click: () => {
            dispatch('click')
        },
    }
    $: if (active === true) {
        currentTab.set(id)
    }
</script>

{#if active}
    <slot />
{/if}
